export const KIND_LABEL: Record<string, string> = {
  switch_refused: 'Hit the phone-change limit',
  many_devices: '3+ phones in 30 days',
  ping_pong: 'Switching back and forth',
  used_after_signout: 'Used a signed-out phone',
  otp_failures: 'Many wrong codes',
  many_networks: 'Many networks in a day',
  legacy_refused: 'Old app refused',
  content_resets: 'Content key reset often',
  no_phone_for_code: 'No phone number for code',
};

export const KIND_KEYS = Object.keys(KIND_LABEL);
